import { render, staticRenderFns } from "./eComplaintFilesTable.vue?vue&type=template&id=16334d4d"
import script from "./eComplaintFilesTable.vue?vue&type=script&lang=js"
export * from "./eComplaintFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports